import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { solstice, julian, planetposition } from 'astronomia';
import { vsop87Bearth } from './vsop87Bearth.js';
import moment from 'moment-timezone';
import CalDate from 'caldate';
import CalEvent from './CalEvent.js';
var earth = new planetposition.Planet(vsop87Bearth);
var Equinox = /*#__PURE__*/function (_CalEvent) {
  _inherits(Equinox, _CalEvent);
  var _super = _createSuper(Equinox);
  /**
   * @param {object} [opts]
   * @param {string} opts.season - type of season (spring|summer|autumn|winter)
   * @param {number|string} opts.offset - offset in days
   */
  function Equinox(opts) {
    var _this;
    _classCallCheck(this, Equinox);
    opts = opts || {};
    _this = _super.call(this, opts);
    _this._season = opts.season;
    _this._timezone = opts.timezone || 'GMT';
    return _this;
  }
  _createClass(Equinox, [{
    key: "inYear",
    value: function inYear(year) {
      var jde;
      switch (this._season) {
        case 'march':
          {
            jde = solstice.march2(year, earth);
            break;
          }
        case 'june':
          {
            jde = solstice.june2(year, earth);
            break;
          }
        case 'september':
          {
            jde = solstice.september2(year, earth);
            break;
          }
        case 'december':
          {
            jde = solstice.december2(year, earth);
            break;
          }
      }
      var str = new julian.Calendar().fromJDE(jde).toDate().toISOString();
      var date;
      if (/^[+-]\d{2}:\d{2}?$/.test(this._timezone)) {
        // for '+08:00' formats
        date = moment(str).utcOffset(this._timezone);
      } else {
        // for 'Asia/Shanghai' formats
        date = moment(str).tz(this._timezone); // move to timezone
      }
      var floorDate = {
        year: year,
        month: date.month() + 1,
        day: date.date()
      };
      var d = new CalDate(floorDate).setOffset(this.offset);
      this.dates.push(d);
      return this;
    }
  }]);
  return Equinox;
}(CalEvent);
export { Equinox as default };